import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { SortDownArrow } from "../../../../assets/svg";
import Action from "../../../../components/common/Action";
import {
  Badge,
  DefaultPrimaryButton,
} from "../../../../components/micro/input";
import DebounceSearch from "../../../../components/common/DebounceSearch";
import RippleLoader from "../../../../components/loader/RippleLoader";
import CustomTable from "../../../../components/customTable/CustomTable";
import ReactSelect from "react-select";
import ReactDatePicker from "react-datepicker";
import {
  createDocument,
  getDocumnetList,
} from "../../../../redux/companies/slice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ViewServiceReport from "../../../serviceRequest/servicereport/ViewServiceReport";
import ViewSales from "../../../sales/ViewSales";
import { toast } from "react-toastify";

const Document = () => {
  const [searchValue, setSearchValue] = useState("");
  const [pageLimit, setPageLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [isLoading, setIsLoading] = useState(false);
  const [bulkaction, setBulkAction] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const [selectedSaleId, setSelectedSaleId] = useState(null);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const location = useLocation();
  const companyData = location?.state?.company;
  const dispatch = useDispatch();
  const DateRange =
    dateRange[0] && dateRange[1]
      ? `${moment(dateRange[0]).format("DD/MM/YYYY")} - ${moment(
          dateRange[1]
        ).format("DD/MM/YYYY")}`
      : "";

  // Selector
  const { documnetList, loading } = useSelector((store) => ({
    documnetList: store?.companiesData?.getDocumnetListStatus?.data?.data,
    loading: store?.companiesData?.loading,
  }));

  useEffect(() => {
    dispatch(
      getDocumnetList({
        search: searchValue,
        pageCount: pageCount,
        pageLimit: pageLimit,
        sort_by: sortBy,
        sort_direction: sortDirection === "asc" ? "asc" : "desc",
        type: selectedType?.value || "",
        date_range: DateRange || "",
        company_id: companyData?.id || "",
      })
    );
  }, [
    searchValue,
    pageCount,
    pageLimit,
    selectedType,
    sortBy,
    sortDirection,
    DateRange,
  ]);

  const handleBulkChange = async (selectedOption) => {
    setBulkAction(selectedOption);

    if (selectedOption?.value === "download") {
      const ids = selectedRows
        .map((item) => item?.document?.id)
        .filter(Boolean);

      try {
        const response = await dispatch(createDocument({ ids })).unwrap();

        const zipUrl = response?.zip;
        if (zipUrl) {
          const a = document.createElement("a");
          a.href = zipUrl;
          a.download = "bulk_documents.zip";
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else {
          toast.error("ZIP URL not found in response.");
        }
      } catch (error) {}

      setBulkAction(null);
      setSelectedRows([]);
      setIsSelectAll(false);
    }
  };

  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption);
  };

  const handleRowSelection = (item, isChecked) => {
    setSelectedRows((prevSelected) => {
      const updated = [...prevSelected];
      const exists = updated.find((row) => row.id === item.id);

      if (isChecked && !exists) {
        updated.push(item);
      } else if (!isChecked && exists) {
        return updated.filter((row) => row.id !== item.id);
      }

      if (updated.length === documnetList?.data?.length) {
        setIsSelectAll(true);
      } else {
        setIsSelectAll(false);
      }

      return updated;
    });
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setIsSelectAll(checked);

    if (checked) {
      setSelectedRows(documnetList?.data?.map((item) => item));
    } else {
      setSelectedRows([]);
    }
  };

  // Export document
  const handleDocumentExportClick = () => {
    if (!documnetList?.data || documnetList?.data.length === 0) {
      alert("No data available to export!");
      return;
    }

    const header = ["Document ID", "Document Name", "Type", "Last Updated"];

    const rows = documnetList?.data.map((equipment) => [
      `"${equipment?.document_id || "-"}"`,
      `"${equipment?.document_name || "-"}"`,
      `"${equipment?.type || "-"}"`,
      `"${equipment?.last_updated || "-"}"`,
    ]);

    let csvContent = header.join(",") + "\n";
    rows.forEach((row) => {
      csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "documents_export.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleDocumentAction = (item) => {
    setSelectedDocumentId([item?.document_id]);
    setSelectedSaleId([item?.sales_id]);
    setSelectedServiceId([item?.service_report_id]);
    setSelectedType(item?.type);
    setIsModal(true);
  };

  // Table Headers
  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div className="flex items-center">
          <input
            type="checkbox"
            className="w-4 h-4 mr-2 accent-themeBtn"
            checked={isSelectAll}
            onChange={handleSelectAll}
          />
          <span>No.</span>
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Document ID
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Document Name
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            setSortBy("type");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Type</span>
          <SortDownArrow
            className={`ml-1 transition-transform ${
              sortDirection === "asc" && sortBy === "type" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            setSortBy("last_updated");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span> Last Updated</span>
          <SortDownArrow
            className={`ml-1 transition-transform ${
              sortDirection === "asc" && sortBy === "last_updated"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start">
        Actions
      </th>
    </>
  );

  // Table Rows
  const DataRows = () => (
    <>
      {(documnetList?.data || []).map((item, index) => (
        <tr
          key={item.id}
          className="text-gray-500 shadow-sm text-mgrey hover:bg-lightprimaryorange"
        >
          <td className="px-5 py-3">
            {" "}
            <div className="flex items-center">
              <input
                type="checkbox"
                className="w-4 h-4 mr-2 accent-themeBtn"
                onChange={(e) => handleRowSelection(item, e.target.checked)}
                checked={selectedRows?.includes(item)}
              />
              {index + 1}
            </div>
          </td>
          <td className="px-5 py-3">{item?.document_id}</td>
          <td className="px-5 py-3">{item?.document_name}</td>
          <td className="px-5 py-3">
            <div className="flex justify-start ">
              <Badge
                className={`capitalize whitespace-nowrap ${
                  item?.type === "receipt"
                    ? "border-bgGreen text-bgGreen"
                    : item?.type === "invoice"
                    ? "border-chipBlue text-chipBlue"
                    : item?.type === "service_report"
                    ? "border-themeBtn text-themeBtn"
                    : ""
                }`}
                value={
                  item?.type === "receipt"
                    ? "Receipt"
                    : item?.type === "invoice"
                    ? "Invoice"
                    : item?.type === "service_report"
                    ? "Service Report"
                    : "" || "-"
                }
              />
            </div>
          </td>
          <td className="px-5 py-3">{item?.last_updated}</td>
          <td className="flex px-5 py-3">
            <Action
              optionList={
                <>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => handleDocumentAction(item)}
                  >
                    View
                  </li>
                  <li
                    className="flex gap-2 items-center px-6 py-2 bg-white hover:bg-hoverTheme transition duration-300 cursor-pointer"
                    onClick={() => handleDocumentAction(item)}
                  >
                    Download
                  </li>
                </>
              }
            />
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <>
      <div className="space-y-5  w-full bg-white shadow rounded-lg p-4">
        <div className="space-y-5">
          {/* Search and Export Section */}
          <div className="flex flex-wrap items-center gap-2 w-full">
            {/* Bulk Action */}
            <div className="w-full sm:w-[200px] md:w-[220px] min-w-[160px]">
              <ReactSelect
                className="w-full text-black p-0"
                id="bulk"
                placeholder="Bulk Action"
                options={[{ value: "download", label: "Download" }]}
                isClearable
                isDisabled={selectedRows?.length === 0}
                getOptionValue={(option) => option?.value}
                getOptionLabel={(option) => option?.label}
                value={bulkaction}
                onChange={handleBulkChange}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: `1px solid #0000003B`,
                    borderColor: bulkaction ? "#F15B29" : "#0000003B",
                    borderRadius: "0.3rem",
                    boxShadow: "none",
                    "&:hover": { border: "1px solid #0000003B" },
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected ? "#F15B29" : "white",
                    "&:active": {
                      backgroundColor: state.isSelected
                        ? "#F15B29"
                        : "rgba(0, 0, 0, 0.04)",
                    },
                  }),
                }}
              />
            </div>

            {/* Type Select */}
            <div className="w-full sm:w-[200px] md:w-[220px] min-w-[160px]">
              <ReactSelect
                className="w-full text-black p-0"
                id="type"
                placeholder="Types"
                options={[
                  { value: "invoice", label: "Invoice" },
                  { value: "receipt", label: "Receipt" },
                  { value: "service_report", label: "Service Report" },
                ]}
                isClearable
                getOptionValue={(option) => option?.value}
                getOptionLabel={(option) => option?.label}
                value={selectedType}
                onChange={handleTypeChange}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: `1px solid #0000003B`,
                    borderColor: selectedType ? "#F15B29" : "#0000003B",
                    borderRadius: "0.3rem",
                    boxShadow: "none",
                    "&:hover": { border: "1px solid #0000003B" },
                  }),
                  option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected ? "#F15B29" : "white",
                    "&:active": {
                      backgroundColor: state.isSelected
                        ? "#F15B29"
                        : "rgba(0, 0, 0, 0.04)",
                    },
                  }),
                }}
              />
            </div>

            {/* Date Range Picker */}
            <div className="w-full sm:w-[200px] md:w-[220px] min-w-[160px]">
              <div className="text-black border border-borderTheme/80 flex justify-between relative rounded w-full px-2 py-[6px] items-center transition duration-300 ease-in-out">
                <ReactDatePicker
                  selected={dateRange[0]}
                  onChange={(dates) => setDateRange(dates)}
                  selectsRange
                  isClearable
                  startDate={dateRange[0]}
                  endDate={dateRange[1]}
                  maxDate={new Date()}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select date range"
                  className="w-full"
                />
              </div>
            </div>

            {/* Search */}
            <div className="w-full sm:flex-1 min-w-[180px]">
              <DebounceSearch
                className="w-full"
                search={searchValue}
                handleChange={setSearchValue}
                placeholder="Search..."
              />
            </div>

            {/* Export Button */}
            <div className="w-full sm:w-auto">
              <DefaultPrimaryButton
                value="EXPORT"
                onClick={handleDocumentExportClick}
              />
            </div>
          </div>

          {/* Loading or Table */}
          {loading ? (
            <RippleLoader />
          ) : (
            <div>
              <CustomTable
                columnHeaders={<ColumnHeaders />}
                dataRows={<DataRows />}
                data={documnetList}
                showPagination
                setPaginationCurrentLimit={setPageLimit}
                paginationCurrentLimit={pageLimit}
                total={documnetList?.total}
                current={pageCount}
                paginationData={(crPage) => setPageCount(crPage)}
              />
            </div>
          )}
        </div>
      </div>

      {isModal && selectedType === "service_report" && (
        <ViewServiceReport
          onClose={() => {
            setIsModal(false);
          }}
          setIsLoading={setIsLoading}
          selectedDocumentId={selectedDocumentId}
          selectedType={selectedType}
          selectedSaleId={selectedServiceId}
          isLoading={isLoading}
          iscompany={"iscompany"}
        />
      )}

      {isModal &&
        (selectedType === "invoice" || selectedType === "receipt") && (
          <ViewSales
            onClose={() => setIsModal(false)}
            setIsLoading={setIsLoading}
            selectedDocumentId={selectedDocumentId}
            selectedType={selectedType}
            selectedSaleId={selectedSaleId}
            selectedServiceId={selectedServiceId}
            isLoading={isLoading}
          />
        )}
    </>
  );
};

export default Document;
